<mat-card appearance="outlined">
  <h3>Interaktive Ausgaben</h3>
  <div class="products">
    <ng-container *ngIf="hasNoneTweebiePackage">
      <div *ngIf="hasSmart" class="product" (click)="openNavigation('installedMobileAppIds')" [class.disabled]="!configAllowed">
        <div [style.background-image]="'url(/assets/img/logos/ibex-smart.png)'"></div>
        <mat-icon class="cog-icon" *ngIf="configAllowed">settings</mat-icon>
      </div>
      <div *ngIf="hasIbextouch" class="product" (click)="openNavigation('installedAppIds')" [class.disabled]="!configAllowed">
        <div [style.background-image]="'url(/assets/img/logos/ibex-touch.png)'"></div>
        <mat-icon class="cog-icon" *ngIf="configAllowed">settings</mat-icon>
      </div>
      <div *ngIf="hasIbextablet" class="product" (click)="openNavigation('installedTabletAppIds')" [class.disabled]="!configAllowed">
        <div [style.background-image]="'url(/assets/img/logos/ibex-tablet.png)'"></div>
        <mat-icon class="cog-icon" *ngIf="configAllowed">settings</mat-icon>
      </div>
      <div *ngIf="hasIbexTV" class="product" (click)="openNavigation('installedTVAppIds')" [class.disabled]="!configAllowed">
        <div [style.background-image]="'url(/assets/img/logos/ibex-tv.png)'"></div>
        <mat-icon class="cog-icon" *ngIf="configAllowed">settings</mat-icon>
      </div>
    </ng-container>
    <div *ngIf="tweebiePackage" class="product">
      <div [style.background-image]="'url(/assets/img/logos/tweebie.png)'"></div>
      <mat-icon>settings</mat-icon>
    </div>
    <div *ngIf="hasTokens && hasIbexinfo" class="product">
      <div [style.background-image]="'url(/assets/img/logos/ibex-info.png)'"></div>
      <mat-icon>settings</mat-icon>
    </div>
  </div>
  <div class="buttons">
    <div class="button" (click)="openConfig('content')">{{ 'dashboard.writeData' | translate }}</div>
  </div>
</mat-card>
